import { UpdateCallCategoryIdDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateCallCategoryIdCallable = getCallable(
  UpdateCallCategoryIdDefinition,
);
